import { render, staticRenderFns } from "./Aerospace.vue?vue&type=template&id=8b09be9e&scoped=true"
import script from "./Aerospace.vue?vue&type=script&lang=js"
export * from "./Aerospace.vue?vue&type=script&lang=js"
import style0 from "./Aerospace.vue?vue&type=style&index=0&id=8b09be9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b09be9e",
  null
  
)

export default component.exports